<template>
  <div>
    <div class="sw-grid-flex sw-grid-flex--align-center sw-grid-flex--wrap--tab">
      <form data-sw-model-material-drag-and-drop-upload-form method="post"
        class="sw-model-material-drag-and-drop-upload__content sw-grid-flex__cell"
        :action="`${uploadAction}?appId=${appId}`"
        enctype="multipart/form-data">
        <input type="hidden" name="appId" :value="appId"/>
        <label for="up3Dfile"
          class="sw-dms--color-grey-46 sw--cursor-pointer">
          <div data-sw-model-material-drag-and-drop-upload-area>
            <div class="sw-grid-flex
                sw-grid-flex--align-center
                sw--padding-vert-4
                sw--padding-hor-3
                sw-dms--bg-grey-96
                sw--border-grey-1
                sw--border-radius-3
                sw--border-style-dashed
                sw-dms--color-grey-46">
              <div class="icon-upload sw--font-size-28 sw--margin-right-3"></div>
              <div>
                <span class="sw--display-none sw--display-block--tab sw--text-underline">Upload a 3D file</span>
                <span class="sw--display-none--tab">Choose a 3D file</span>
                <input data-sw-model-material-drag-and-drop-upload-file-input
                  class="sw--display-none"
                  type="file" id="up3Dfile"
                  name="file"
                  :accept="acceptedModelExtensions"
                  :data-sw-max-file-size="maxUploadSize">
                <span class="sw--display-none--tab"> or drag it here</span>
              </div>

              <label for="drop-zone-scale"
                class="sw-grid-flex sw-grid-flex--align-center sw--margin-left-auto sw-dms--color-grey-46">
                <span class="sw--font-size-12">UNITS: </span>
                <div class="sw-dropdown--plain sw-dropdown__container sw--border-none">
                  <select data-sw-dropdown data-sw-dropdown-vendor="selectric" id="drop-zone-scale" name="scale"
                    class="sw-dropdown__select sw-dms--color-grey-46">
                    <option selected :value="scaleMillimeters">MM</option>
                    <option :value="scaleMeters">M</option>
                    <option :value="scaleInches">IN</option>
                  </select>
                </div>
              </label>
            </div>
          </div>
        </label>
        <div data-sw-model-material-drag-and-drop-upload-uploading
          class="sw-model-material-drag-and-drop-upload__content
            sw-model-material-drag-and-drop-upload__uploading
            sw--is-hidden
            sw-grid-flex
            sw-grid-flex--align-center
            sw--position-relative
            sw-grid-flex
            sw-grid-flex--align-center
            sw--padding-hor-4
            sw-dms--bg-grey-96
            sw--border-transparent-1
            sw--border-radius-3
            sw--margin-bottom-1">
          <div class="sw-dms--color-grey-46 sw--margin-left-2">Uploading Your Model</div>
          <div data-sw-model-material-drag-and-drop-upload-progress-bar
            class="sw-model-material-drag-and-drop-upload__progress-bar
              sw-dms--bg-purple
              sw--position-absolute
              sw--position-left
              sw--position-bottom
              sw--border-radius-2"></div>
        </div>
      </form>

      <div class="sw--margin-left-2 sw--margin-left-0--tab sw--margin-vert-2--tab" v-if="showDesignWithShapeways">
        <div class="sw--margin-left-2 sw--margin-right-2 sw--display-inline">
          or
        </div>
        <a :href="designWithShapewaysUrl"
          class="sw-dms-button sw-dms-button--red sw-dms-button--small sw-dms--box-shadow">
          Don't have a 3d File?
        </a>
      </div>
    </div>
    <div class="sw-model-material-drag-and-drop-upload__content sw--is-hidden"
      data-sw-model-material-drag-and-drop-upload-file-error>
      <div class="sw-grid-flex__cell
          sw-grid-flex
          sw-grid-flex--align-center
          sw--padding-4
          sw--bg-alert-red-lightest
          sw--border-radius-3
          sw--position-relative
          sw--margin-top-2">
        <div class="icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"></div>
        <div data-sw-model-material-drag-and-drop-upload-file-count-error class="sw--is-hidden">
          Wait up! Our systems can only handle one file at a time! Please try uploading again with a single file.
        </div>
        <div data-sw-model-material-drag-and-drop-upload-file-format-error class="sw--is-hidden">
          Oh no! We don’t support this file format. Check out our
          <a class="sw--margin-left-auto" @click.prevent="openSupportedFileTypes">
            <span class="sw--text-decoration-underline sw-dms--text-dark">Supported file types</span>
          </a>.
        </div>
        <div data-sw-model-material-drag-and-drop-upload-file-size-error class="sw--is-hidden">
          Oh no! Your file size is too big for us to process. Please try again with another file.
        </div>
        <div data-sw-model-material-drag-and-drop-upload-generic-error class="sw--is-hidden">
          Oh no! Something went wrong and we couldn’t process your file. Please try again in a few minutes!
        </div>
        <div data-sw-model-material-drag-and-drop-upload-error class="sw--is-hidden">
          <!--Placeholder for front end error message-->
        </div>
      </div>
      <!--This spacer div is to make sure the upload element and the error are the same width-->
      <div class="sw-model-material-drag-and-drop-upload__content-error-spacer"></div>
    </div>
    <div class="sw--font-size-12">New part volume should not be more than 10% than the original part volume.</div>
    <a @click.prevent="openSupportedFileTypes">
      <span class="sw--font-size-12 sw--text-decoration-underline sw-dms--text-light">Supported file types</span>
    </a>
  </div>
</template>

<script>
  import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
  import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
  import VueExternalModuleMixin from 'js/lib/vue/mixins/vue-external-module-mixin';
  import swDropdown from 'js/sw-jquery/view-builders/sw-dropdown';
  import ModelMaterialDragAndDropUpload
    from 'rrViewComponents/Model/MaterialConfigurator/ModelMaterialDragAndDropUploadComponent/ModelMaterialDragAndDropUpload';
  import supportedFileTypesTemplate
    from 'rrViewComponents/Model/Fix/ModelFixDragAndDropUploadComponent/supported-file-types-noty.mustache';

  export default {
    name: 'model-fix-drag-and-drop-upload',

    mixins: [VueJQueryMixin, VueSwMixin, VueExternalModuleMixin],

    props: {
      uploadAction: {
        type: String,
        required: true,
      },
      appId: {
        type: String,
        required: true
      },
      acceptedModelExtensions: {
        type: String,
        required: true
      },
      maxUploadSize: {
        type: Number,
        required: true
      },
      scaleMillimeters: {
        type: Number,
        required: true
      },
      scaleMeters: {
        type: Number,
        required: true
      },
      scaleInches: {
        type: Number,
        required: true
      },
      showDesignWithShapeways: {
        type: Boolean,
        default: false
      },
      designWithShapewaysUrl: {
        type: String
      }
    },

    mounted() {
      const _this = this;
      const $el = this.$jQuery(this.$el);

      $el.on('success', function (e, data) {
        _this.$emit('success', data);
      });

      $el.on('error', function (e, data) {
        _this.$emit('error', data);
      });

      _this.loadExternalModule(function () {
        new ModelMaterialDragAndDropUpload({el: $el});
        swDropdown($el);
      });
    },

    methods: {
      openSupportedFileTypes() {
        this.$sw.notifications.full('', {
          modal: true,
          layout: 'center',
          template: supportedFileTypesTemplate,
          closeWith: ['button', 'backdrop']
        });
      }
    }
  }
</script>
